import * as core from '../../../../../../../core'

import { query } from './projects-table-updated-org-structure.query'

export const RESOURCE = {
  payload: {
    alias: 'rp.explore.widgets.projects-table',
    description:
      'Displays a list of projects in a table widget without Award Funding or IDC related metrics',
    name: 'RP Explore - Projects Table',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
